const initialFormData = {
  filename: '',
  base64: '',
  dealerId: null,
};

export default {
  name: 'RttTable',
  props: {
    list: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      isFormOpen: false,
      formData: { ...initialFormData },
    };
  },
  computed: {
    user() { return this.$store.state.user; },
    cantSave() { return !this.formData?.base64; },
  },
  watch: {
    isFormOpen(val) {
      if (!val) {
        this.ClearForm();
      }
    },
  },
  methods: {
    ClearForm() {
      if (this.$refs.form && typeof this.$refs.form.reset === 'function') {
        this.$refs.form.reset();
        this.formData = { ...initialFormData };
      }
    },
    DownloadDocument(dealerId) {
      console.log(dealerId);
      this.$store.dispatch('DownloadFile', {
        url: 'profiles/api/dealers/download-blob',
        data: {
          profile_id: this.user.profile_id,
          dealer_id: dealerId,
        },
        filename: `форма_согласия_${dealerId}_${this.user.profile_id}.pdf`,
      });
    // для скачивания документа на подпись
    },
    OnFormOpen(dealerId) {
      this.formData.dealerId = dealerId;
      this.isFormOpen = true;
    },
    PickDocument() {
      this.$refs.file.click();
    },
    OnFilePicked(e) {
      const app = this;
      const { files } = e.target;
      if (files[0] !== undefined) {
        app.formData.filename = files[0].name;
        const fr = new FileReader();
        fr.readAsDataURL(files[0]);
        fr.addEventListener('load', () => {
          app.formData.base64 = fr.result;
          app.$forceUpdate();
        });
      }
    },
    UploadDocument() {
      const app = this;
      app.$store.getters.axl.post('profiles/api/dealers/upload', {
        profile_id: this.user.profile_id,
        dealer_id: this.formData.dealerId,
        documents: this.formData.base64,
      })
        .then(() => {
          app.$store.dispatch('GetProfile');
          app.isFormOpen = false;
        })
        .catch((error) => {
          app.$store.dispatch('HandleError', error);
        });
    },
  },
};
